<template>
	<v-row>
		<v-col cols="12" sm="1">
			<botao-cancelar
				class="botao-cancelar-confirmar"
				@cancelar="acaoCancelar"
				tamanho-largura="100"
				:label="nomeBotaoCancelar"
				v-az-auth="permissaoCancelar"
			></botao-cancelar>
		</v-col>
		<v-col cols="12" offset-sm="9" sm="2">
			<botao-primario
				v-if="isConfirmarVisivel"
				id="btnConfirmarModal"
				tamanho-largura="100"
				:block="$vuetify.breakpoint.smAndDown"
				class="botao-cancelar-confirmar float-sm-right"
				:cor-de-fundo="corDoBotaoConfirmar"
				:nome-botao="nomeBotaoConfirmar"
				v-az-auth="permissaoConfirmar"
				:disabled="isConfirmarDesabilitado"
				@click="trataAcaoDeBotaoDesabilitado(acaoConfirmar, isConfirmarDesabilitado)"
			>
			</botao-primario>
		</v-col>
	</v-row>
</template>
<script>
import trataAcaoDeBotaoDesabilitado from '@/views/mixins/trataAcaoDeBotaoDesabilitado'

export default {
	name: 'botao-cancelar-confirmar',
	mixins: [trataAcaoDeBotaoDesabilitado],
	props: {
		acaoCancelar: {
			type: Function,
			default: () => {
				alert('Ação de cancelar não implementada')
			},
		},
		acaoConfirmar: {
			type: Function,
			default: () => {
				alert('Ação de confirmar não implementada')
			},
		},
		nomeBotaoConfirmar: {
			type: String,
			default: 'Confirmar',
		},
		nomeBotaoCancelar: {
			type: String,
			default: 'CANCELAR',
		},
		corDoBotaoConfirmar: {
			type: String,
			default: 'primary',
		},
		isConfirmarVisivel: {
			type: Boolean,
		},
		isConfirmarDesabilitado: {
			type: Boolean,
		},
		permissaoConfirmar: {
			type: String,
			default: '',
		},
		permissaoCancelar: {
			type: String,
			default: '',
		},
	},
}
</script>
<style lang="stylus">
#btnConfirmarModal
	&:disabled
		cursor not-allowed
</style>
